import { api } from '@/api/client';

export type InviteRole = 'admin' | 'member' | 'viewer';
export type InviteStatus = 'pending' | 'accepted' | 'revoked' | 'expired';

export interface InviteListItem {
  id: string;
  email: string;
  role: string;
  created_by: string | null;
  created_at: string;
  expires_at: string;
  accepted_at: string | null;
  status: InviteStatus;
}

export interface InviteCreateResponse extends InviteListItem {
  token: string;
  accept_url: string;
  /** `true` dacă serverul are SMTP configurat și mesajul a plecat. */
  email_sent: boolean;
}

export interface InvitePublicMeta {
  email: string;
  tenant_name: string;
  tenant_slug: string;
  role: string;
  expires_at: string;
}

export const invitesApi = {
  list: (tenantId: string) =>
    api.get<InviteListItem[]>(`/tenants/${tenantId}/invites`),

  create: (tenantId: string, req: { email: string; role: InviteRole; expires_days?: number }) =>
    api.post<InviteCreateResponse>(`/tenants/${tenantId}/invites`, req),

  revoke: (tenantId: string, inviteId: string) =>
    api.delete<null>(`/tenants/${tenantId}/invites/${inviteId}`),

  // Tokenul merge în body, nu în URL — URL-urile ajung în access log.
  getMeta: (token: string) => api.post<InvitePublicMeta>('/invites/lookup', { token }),

  accept: (token: string) =>
    api.post<{ tenant_id: string; role: string }>('/invites/accept', { token }),
};
